import { OptionItem } from 'tno-core';

export const toningOptions = [
  new OptionItem('-5', -5),
  new OptionItem('-4', -4),
  new OptionItem('-3', -3),
  new OptionItem('-2', -2),
  new OptionItem('-1', -1),
  new OptionItem('0', 0),
  new OptionItem('1', 1),
  new OptionItem('2', 2),
  new OptionItem('3', 3),
  new OptionItem('4', 4),
  new OptionItem('5', 5),
];
